import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b246cd8c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "homebox clearfix"
};
const _hoisted_2 = {
  class: "home-main-wrapper"
};
const _hoisted_3 = {
  class: "owin-height"
};
const _hoisted_4 = {
  class: "notice-top"
};
const _hoisted_5 = {
  class: "text"
};
const _hoisted_6 = {
  class: "notice-total"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 共 ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 条相关内容 ");

const _hoisted_9 = {
  class: "notice-wrapper"
};
const _hoisted_10 = {
  class: "nav-list"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "notice-list-wrapper"
};
const _hoisted_13 = {
  class: "notice-list"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["title", "innerHTML"];
const _hoisted_16 = {
  class: "notice-count"
};
const _hoisted_17 = {
  class: "date"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "|")], -1));

const _hoisted_19 = {
  style: {
    "width": "120px"
  }
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "浏览量", -1));

const _hoisted_21 = {
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_22 = {
  key: 0,
  class: "empty-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_affix = _resolveComponent("el-affix");

  const _component_Empty = _resolveComponent("Empty");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    menuCode: '10701',
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event)
  }, null, 8, ["menuInfo"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString($data.menuInfo.nav_name) + "  ", 1), _withDirectives(_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", null, _toDisplayString($data.pageInfo.rows), 1), _hoisted_8], 512), [[_vShow, $data.showSearchResult]]), _createVNode(_component_el_input, {
    modelValue: $data.newsName,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.newsName = $event),
    size: "default",
    class: "search-input",
    onKeyup: _cache[3] || (_cache[3] = _withKeys($event => $options.handleSearch(), ["enter"])),
    placeholder: "搜索新闻资讯"
  }, {
    suffix: _withCtx(() => [_createElementVNode("i", {
      class: "iconfont icon-sousuo search-icon",
      onClick: _cache[1] || (_cache[1] = $event => $options.handleSearch())
    })]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [$data.newsTypeList && $data.newsTypeList.length ? (_openBlock(), _createBlock(_component_el_affix, {
    key: 0,
    offset: 0
  }, {
    default: _withCtx(() => [_createElementVNode("ul", _hoisted_10, [_createElementVNode("li", {
      onClick: _cache[4] || (_cache[4] = $event => $options.handleSearch()),
      class: _normalizeClass(["nav", !$data.pageInfo.newsTypeId && 'active'])
    }, " 首页 ", 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsTypeList, ({
      id,
      name
    }) => {
      return _openBlock(), _createElementBlock("li", {
        onClick: $event => $options.handleSearch(id),
        class: _normalizeClass(["nav", $data.pageInfo.newsTypeId === id && 'active']),
        key: id
      }, _toDisplayString(name), 11, _hoisted_11);
    }), 128))])]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "notice-item",
      key: item.id,
      onClick: $event => $options.showNewsDetail(item)
    }, [_createElementVNode("div", {
      class: "notice-title text-overflow",
      title: item.name,
      "data-html": "",
      innerHTML: $options.kewordFilter(item.news_name)
    }, null, 8, _hoisted_15), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_17, _toDisplayString($options.dayjs(item.publish_time).format('YYYY-MM-DD')), 1)]), _hoisted_18, _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("span", _hoisted_21, _toDisplayString(item.view_num || 0), 1)])])], 8, _hoisted_14);
  }), 128))]), !$data.newsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_Empty, {
    text: "暂无数据"
  })])) : _createCommentVNode("", true), $data.pageInfo.rows && $data.pageInfo.rows > $data.pageInfo.pageLimit ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 1,
    style: {
      "margin-top": "20px"
    },
    background: "",
    layout: "prev, pager, next",
    "prev-text": "上一页",
    "next-text": "下一页",
    onCurrentChange: $options.pageIndexChange,
    "current-page": $data.pageInfo.pageIndex,
    total: $data.pageInfo.rows,
    "page-size": $data.pageInfo.pageLimit
  }, null, 8, ["onCurrentChange", "current-page", "total", "page-size"])) : _createCommentVNode("", true)])])])]), _createVNode(_component_Footer)]);
}